define('modules/editor/models/property_groups/action',['require','exports','module','./base'],function (require, exports, module) {
  "use strict";
  var BasePropertyGroup = require("./base");
  // action property for buttons/links
  module.exports = BasePropertyGroup.extend({
    name: "action",
    properties: ["url", "target"],
    applyStyles: function($el){
      var theLink = $el.find("a");
      if(this.get("url") !== ""){
        theLink.attr("href", this.get("url"));
      }
      theLink.attr("target", this.get("target"));
    },
    validators: {
      "url": function(attrs){
        return attrs.url === "" || this.isValidUrl(attrs.url) || this.isValidAnchorName(attrs.url);
      }
    }
  });
});

